import { render, staticRenderFns } from "./ibc_searchscore_info.vue?vue&type=template&id=5619ca94&"
import script from "./ibc_searchscore_info.vue?vue&type=script&lang=js&"
export * from "./ibc_searchscore_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports